// Module
var code = " <gh-dialog layout=\"catalog\"> <gh-dialog-header [title]=\"title\"></gh-dialog-header> <gh-dialog-content><img [src]=\"url\"></gh-dialog-content> </gh-dialog>";
// Exports
module.exports = code;